module.exports = __webpack_public_path__ + "images/down-arrow-sp_47ede3c0b20961a484827a36c712c8ae.png";